export default "__VITE_ASSET__BYKwI$Fd__"